import * as React from 'react';

import { cn } from '../../lib/utils';

// Lightweight avatar (no Radix dependency) — leads have no photos, so this is
// an initials/fallback circle. Compose: <Avatar><AvatarFallback>BH</AvatarFallback></Avatar>.
const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full',
      className,
    )}
    {...props}
  />
));
Avatar.displayName = 'Avatar';

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      // bg-muted (same token value) — Bootstrap's .bg-secondary hijacks the bare class.
      'flex h-full w-full items-center justify-center rounded-full bg-muted text-sm font-semibold text-secondary-foreground',
      className,
    )}
    {...props}
  />
));
AvatarFallback.displayName = 'AvatarFallback';

export { Avatar, AvatarFallback };
